// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class NpiIdentifierResponseModel {
    'identifier'?: string;
    'code'?: string;
    'state'?: string;
    'issuer'?: string;
    'desc'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof NpiIdentifierResponseModel>> = [
        {
            "name":     "identifier",
            "baseName": "identifier",
            "type":     "string"
        },
        {
            "name":     "code",
            "baseName": "code",
            "type":     "string"
        },
        {
            "name":     "state",
            "baseName": "state",
            "type":     "string"
        },
        {
            "name":     "issuer",
            "baseName": "issuer",
            "type":     "string"
        },
        {
            "name":     "desc",
            "baseName": "desc",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return NpiIdentifierResponseModel.attributeTypeMap;
    }
}
